import { createTheming } from '@callstack/react-theme-provider';
import logoSinglifeWhite from '@assets/images/logo-singlife-white.svg';
import logoSinglifeRed from '@assets/images/logo-singlife-white.svg';

interface IColor {
  primary: string;
  white: string;
  grey: any;
  blue: any;
  green: any;
  red: any;
  secondary: string;
}

interface IFontSize {
  title: number;
  smallTitle: number;
  subtitle: number;
  label: number;
  text: number;
  description: number;
  bigTitle: number;
  bigSub: number;
}

interface IconSize {
  xsm: number;
  sm: number;
  md: number;
  lg: number;
  dlg: number;
}
export interface ITheme {
  logoRed: string;
  logoWhite: string;
  colors: IColor;
  fontFamily: string;
  fontSize: IFontSize;
  fontSizeTablet: IFontSize;
  iconSize: IconSize;
}

export const themeDefault: ITheme = {
  logoRed: logoSinglifeRed,
  logoWhite: logoSinglifeWhite,
  colors: {
    primary: '#ff0008',
    white: '#ffffff',
    secondary: '#616161',
    grey: {
      100: '#aaaaaa',
      200: '#f9f9f9',
      300: '#5c596d',
      400: '#6f6d80',
      500: '#444444',
      600: '#eeeeee',
      700: '#cccccc',
      800: '#333333',
      900: '#999999',
      1000: '#D8D8D8',
      1100: '#616161'
    },
    blue: {
      100: '#ecf8ff',
      200: '#004fb6',
      300: '#44c0ff',
      400: '#1a61bd',
      500: '#f5f8fc',
      600: '#dce6f4'
    },
    green: {
      100: '#4f9f31',
      200: '#4ca02b',
      
    },
    red: {
      100: '#f8e9e9',
      200: '#bd2624',
      300: '#87378e',
      400: '#d90007',
      500: '#d90006',
      600: '#c80a00'
    }
  },
  fontFamily: 'source_sans_pro_vf, -apple-system, system-ui, sans-serif',
  fontSize: {
    title: 32, // 42
    smallTitle: 28, 
    subtitle: 24, // 28
    label: 20,
    text: 16,
    description: 14,
    bigTitle: 42,
    bigSub: 26,
  },
  fontSizeTablet: {
    title: 42,
    smallTitle: 28, 
    subtitle: 28,
    label: 20,
    text: 16,
    description: 14,
    bigTitle: 42,
    bigSub: 26,
  },
  iconSize: {
    xsm: 14,
    sm: 16,
    md: 25,
    lg: 35,
    dlg: 65
  }
}

export const { ThemeProvider, withTheme, useTheme } = createTheming(themeDefault)
